/**
 * REKKIE Intelligence page client (/api/intelligence).
 */
import { getIdToken } from '../contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../config/api';

async function authedFetch(endpoint) {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Not authenticated. Please log in.');
  const response = await fetch(buildApiUrl(endpoint), {
    headers: { 'Content-Type': 'application/json', ...getAuthHeaders(idToken) },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.message || body.error || `Request failed: ${response.statusText}`);
    error.status = response.status;
    throw error;
  }
  return body;
}

/**
 * Offboard Agent questions logged in [start, end).
 * @param {Date} start
 * @param {Date} end
 * @returns {Promise<{ start, end, timezone, truncated, maxRows, summary, utterances }>}
 */
export const fetchAgentUtterances = (start, end) =>
  authedFetch(`/intelligence/utterances?start=${encodeURIComponent(start.toISOString())}&end=${encodeURIComponent(end.toISOString())}`);
